exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.project-profile-map-legend{background-color:#c3bc9f\n}\n.project-create-edit input::placeholder{color:#0b7fc7;opacity:.54\n}", ""]);

// exports
